import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const styles = {
    tooltipContainer: {
        position: "relative",
        display: "inline-block",
    },
    tooltip: {
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#555",
        color: "white",
        padding: "10px",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        zIndex: 1000,
        opacity: 0,
        visibility: "hidden",
        transition: "opacity 0.3s, visibility 0.3s",
    },
    tooltipVisible: {
        opacity: 1,
        visibility: "visible",
    },
};

const ModalStatus = (props) => {
    const [visible, setVisible] = useState(false);

    const showTooltip = () => setVisible(true);
    const hideTooltip = () => setVisible(false);

    useEffect(() => {
        if (props.open) {
            showTooltip();
        }
    }, [props.open]);

    return (
        <div
            className={styles.tooltipContainer}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            <div
                className={`${styles.tooltip} ${visible ? styles.tooltipVisible : ""}`}
            >
                {props.open}
            </div>
        </div>
    );
};

export default ModalStatus;
